import { CSSProperties, ReactNode, useState } from 'react';
import { IPageLink } from '@vivli/shared/infrastructure/interface';
import { HorizontalNavView } from '../horizontal-nav/horizontal-nav.view';
import { Size } from '@vivli/shared/theme';

const containerStyle: CSSProperties = {
    backgroundColor: 'rgb(233, 234, 239)',
    overflowY: 'auto',
    overflowX: 'hidden',
    display: 'grid',
    gridTemplateRows: 'auto 1fr',
    width: '100%',
    height: '100%'
};

const loadingStyle: CSSProperties = {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    backgroundColor: 'rgba(255,255,255,0.7)',
    zIndex: 99999
};

const tabPaddingStyle: CSSProperties = {
    paddingBottom: Size.PADDING + 5,
    backgroundColor: 'rgb(233, 234, 239)'
};

const pageStyle: CSSProperties = {
    display: 'grid',
    gridTemplateColumns: 'auto',
    height: '100%',
    width: '100%',
    overflowY: 'hidden',
    overflowX: 'hidden'
};

const bodyStyle: CSSProperties = {
    display: 'grid',
    gridTemplateRows: '1fr',
    rowGap: '20px',
    overflow: 'hidden',
    height: '100%',
    width: '100%'
};

interface PageBodyViewProps {
    horizontalTabs?: boolean;
    onTabClick?: (link: IPageLink) => void;
    links: IPageLink[];
    isLoading?: boolean;
    defaultLink?: IPageLink;
    onActiveLinkChange?: (link: IPageLink) => void; // notify parent when active link changes
    forTopTabSet?: boolean; // if true, use the top tab rules for horizontal tabs
    // Optional interceptor run before a tab switch; return false (or a Promise resolving false) to
    // veto the switch. Used to confirm before leaving during a file upload.
    beforeTabChange?: (link: IPageLink) => boolean | Promise<boolean>;
}

//this view is for the INSIDE of a page,
//optionally including horizontal tabs,
// under the header and to the right of any vertical
//tabs, should they exist
export const PageBodyView = ({
    horizontalTabs,
    onTabClick,
    links,
    isLoading,
    defaultLink,
    onActiveLinkChange = () => {},
    forTopTabSet,
    beforeTabChange
}: PageBodyViewProps) => {
    // Track the active tab by url rather than by link object. Holding the object would freeze it at
    // the first render's value, so the rendered tab body could never see updated props or counts.
    // (DEV-759)
    const [activeUrl, setActiveUrl] = useState<string>(defaultLink?.url);
    const activeLink = links?.find((link) => link.url === activeUrl) ?? defaultLink;

    const handleNavTabClick = (link: IPageLink) => {
        if (isLoading) {
            return;
        }

        setActiveUrl(link?.url);
        onActiveLinkChange && onActiveLinkChange(link);
        onTabClick && onTabClick(link);
    };

    return (
        <div style={containerStyle}>
            {horizontalTabs && (
                <div style={tabPaddingStyle}>
                    <HorizontalNavView
                        onTabClick={handleNavTabClick}
                        links={links}
                        activeLink={activeLink}
                        isLoading={isLoading}
                        topTabSet={forTopTabSet}
                        beforeTabChange={beforeTabChange}
                    />
                </div>
            )}
            <div style={pageStyle}>
                <div style={bodyStyle}>
                    <div>{activeLink?.component}</div>
                </div>
            </div>
        </div>
    );
};
